/**
 * Axios Instance with Dynamic Base URL
 * Automatically uses Railway backend URL in production
 */
import axios from 'axios';
import { API_URL } from '../config/api.config';
import { watchFormDataMutations } from './api';

// Create axios instance with base URL from environment
const axiosInstance = axios.create({
  baseURL: API_URL,
  timeout: 30000, // 30 seconds
  headers: {
    'Content-Type': 'application/json'
  }
});

// Request interceptor - add auth token
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Clear the cached categories/products when they're changed through this client
watchFormDataMutations(axiosInstance);

// Response interceptor - handle errors
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // If we are already on the login page, don't redirect or clear session, just let the form handle it
      if (window.location.pathname === '/login') {
        return Promise.reject(error);
      }

      // Unauthorized - redirect to login and clear session
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      localStorage.setItem('session_expired_message', 'true');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);



// Log configuration in development
if (process.env.NODE_ENV === 'development') {
  console.log('🔧 Axios Configuration:');
  console.log('  Base URL:', API_URL);
}

export default axiosInstance;
